export default __webpack_public_path__ + "static/GT-America-Standard-Light-4f56572b2f72b19f6fa82d46546fec01.eot";